const AllQuestions = [


  {
    "id": "260121pyq1math1",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol1.png"
  },
  {
    "id": "260121pyq1math2",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1mathsol2.png"
  },
  {
    "id": "260121pyq1math3",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol3.png"
  },
  {
    "id": "260121pyq1math4",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol4.png"
  },
  {
    "id": "260121pyq1math5",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol5.png"
  },

  {
    "id": "260121pyq1math6",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol6.png"
  },
  {
    "id": "260121pyq1math7",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol7.png"
  },
  {
    "id": "260121pyq1math8",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1mathsol8.png"
  },
  {
    "id": "260121pyq1math9",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol9.png"
  },
  {
    "id": "260121pyq1math10",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol10.png"
  },
  {
    "id": "260121pyq1math11",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol11.png"
  },
  {
    "id": "260121pyq1math12",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol12.png"
  },
  {
    "id": "260121pyq1math13",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol13.png"
  },
  {
    "id": "260121pyq1math14",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol14.png"
  },
  {
    "id": "260121pyq1math15",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol15.png"
  },
  {
    "id": "260121pyq1math16",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol16.png"
  },
  {
    "id": "260121pyq1math17",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol17.png"
  },
  {
    "id": "260121pyq1math18",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1mathsol18.png"
  },
  {
    "id": "260121pyq1math19",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1mathsol19.png"
  },
  {
    "id": "260121pyq1math20",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol20.png"
  },


  {
    "id": "260121pyq1phy1",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol1.png"
  },
  {
    "id": "260121pyq1phy2",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol2.png"
  },
  {
    "id": "260121pyq1phy3",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol3.png"
  },
  {
    "id": "260121pyq1phy4",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol4.png"
  },
  {
    "id": "260121pyq1phy5",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol5.png"
  },

  {
    "id": "260121pyq1phy6",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1physol6.png"
  },
  {
    "id": "260121pyq1phy7",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1physol7.png"
  },
  {
    "id": "260121pyq1phy8",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol8.png"
  },
  {
    "id": "260121pyq1phy9",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol9.png"
  },
  {
    "id": "260121pyq1phy10",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol10.png"
  },
  {
    "id": "260121pyq1phy11",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol11.png"
  },
  {
    "id": "260121pyq1phy12",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol12.png"
  },
  {
    "id": "260121pyq1phy13",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol13.png"
  },
  {
    "id": "260121pyq1phy14",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1physol14.png"
  },
  {
    "id": "260121pyq1phy15",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1physol15.png"
  },
  {
    "id": "260121pyq1phy16",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol16.png"
  },
  {
    "id": "260121pyq1phy17",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol17.png"
  },
  {
    "id": "260121pyq1phy18",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol18.png"
  },
  {
    "id": "260121pyq1phy19",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol19.png"
  },
  {
    "id": "260121pyq1phy20",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol20.png"
  },

  {
    "id": "260121pyq1che1",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol1.png"
  },
  {
    "id": "260121pyq1che2",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol2.png"
  },
  {
    "id": "260121pyq1che3",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol3.png"
  },
  {
    "id": "260121pyq1che4",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol4.png"
  },
  {
    "id": "260121pyq1che5",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol5.png"
  },

  {
    "id": "260121pyq1che6",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol6.png"
  },
  {
    "id": "260121pyq1che7",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol7.png"
  },
  {
    "id": "260121pyq1che8",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol8.png"
  },
  {
    "id": "260121pyq1che9",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol9.png"
  },
  {
    "id": "260121pyq1che10",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol10.png"
  },
  {
    "id": "260121pyq1che11",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1chesol11.png"
  },
  {
    "id": "260121pyq1che12",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol12.png"
  },
  {
    "id": "260121pyq1che13",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol13.png"
  },
  {
    "id": "260121pyq1che14",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol14.png"
  },
  {
    "id": "260121pyq1che15",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol15.png"
  },
  {
    "id": "260121pyq1che16",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol16.png"
  },
  {
    "id": "260121pyq1che17",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol17.png"
  },
  {
    "id": "260121pyq1che18",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol18.png"
  },
  {
    "id": "260121pyq1che19",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol19.png"
  },
  {
    "id": "260121pyq1che80",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol20.png"
  },


    {
    "id": "260121pyq2math1",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol1.png"
  },
  {
    "id": "260121pyq2math2",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2mathsol2.png"
  },
  {
    "id": "260121pyq2math3",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol3.png"
  },
  {
    "id": "260121pyq2math4",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol4.png"
  },
  {
    "id": "260121pyq2math5",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2mathsol5.png"
  },

  {
    "id": "260121pyq2math6",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2mathsol6.png"
  },
  {
    "id": "260121pyq2math7",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol7.png"
  },
  {
    "id": "260121pyq2math8",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2mathsol8.png"
  },
  {
    "id": "260121pyq2math9",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol9.png"
  },
  {
    "id": "260121pyq2math10",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2mathsol10.png"
  },
  {
    "id": "260121pyq2math11",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol11.png"
  },
  {
    "id": "260121pyq2math12",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol12.png"
  },
  {
    "id": "260121pyq2math13",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol13.png"
  },
  {
    "id": "260121pyq2math14",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2mathsol14.png"
  },
  {
    "id": "260121pyq2math15",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol15.png"
  },
  {
    "id": "260121pyq2math16",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol16.png"
  },
  {
    "id": "260121pyq2math17",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2mathsol17.png"
  },
  {
    "id": "260121pyq2math18",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol18.png"
  },
  {
    "id": "260121pyq2math19",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol19.png"
  },
  {
    "id": "260121pyq2math20",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol20.png"
  },


  {
    "id": "260121pyq2phy1",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol1.png"
  },
  {
    "id": "260121pyq2phy2",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol2.png"
  },
  {
    "id": "260121pyq2phy3",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol3.png"
  },
  {
    "id": "260121pyq2phy4",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol4.png"
  },
  {
    "id": "260121pyq2phy5",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol5.png"
  },

  {
    "id": "260121pyq2phy6",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol6.png"
  },
  {
    "id": "260121pyq2phy7",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol7.png"
  },
  {
    "id": "260121pyq2phy8",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol8.png"
  },
  {
    "id": "260121pyq2phy9",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol9.png"
  },
  {
    "id": "260121pyq2phy10",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2physol10.png"
  },
  {
    "id": "260121pyq2phy11",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2physol11.png"
  },
  {
    "id": "260121pyq2phy12",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol12.png"
  },
  {
    "id": "260121pyq2phy13",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol13.png"
  },
  {
    "id": "260121pyq2phy14",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol14.png"
  },
  {
    "id": "260121pyq2phy15",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol15.png"
  },
  {
    "id": "260121pyq2phy16",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol16.png"
  },
  {
    "id": "260121pyq2phy17",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol17.png"
  },
  {
    "id": "260121pyq2phy18",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2physol18.png"
  },
  {
    "id": "260121pyq2phy19",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol19.png"
  },
  {
    "id": "260121pyq2phy20",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol20.png"
  },

  {
    "id": "260121pyq2che1",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2chesol1.png"
  },
  {
    "id": "260121pyq2che2",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol2.png"
  },
  {
    "id": "260121pyq2che3",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2chesol3.png"
  },
  {
    "id": "260121pyq2che4",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol4.png"
  },
  {
    "id": "260121pyq2che5",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol5.png"
  },

  {
    "id": "260121pyq2che6",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol6.png"
  },
  {
    "id": "260121pyq2che7",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2chesol7.png"
  },
  {
    "id": "260121pyq2che8",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol8.png"
  },
  {
    "id": "260121pyq2che9",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol9.png"
  },
  {
    "id": "260121pyq2che10",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol10.png"
  },
  {
    "id": "260121pyq2che11",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2chesol11.png"
  },
  {
    "id": "260121pyq2che12",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2chesol12.png"
  },
  {
    "id": "260121pyq2che13",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol13.png"
  },
  {
    "id": "260121pyq2che14",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol14.png"
  },
  {
    "id": "260121pyq2che15",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol15.png"
  },
  {
    "id": "260121pyq2che16",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol16.png"
  },
  {
    "id": "260121pyq2che17",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol17.png"
  },
  {
    "id": "260121pyq2che18",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2chesol18.png"
  },
  {
    "id": "260121pyq2che19",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol19.png"
  },
  {
    "id": "260121pyq2che80",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol20.png"
  },



  
  {
    "id": "260122pyq1math1",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1mathsol1.png"
  },
  {
    "id": "260122pyq1math2",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1mathsol2.png"
  },
  {
    "id": "260122pyq1math3",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1mathsol3.png"
  },
  {
    "id": "260122pyq1math4",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1mathsol4.png"
  },
  {
    "id": "260122pyq1math5",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1mathsol5.png"
  },

  {
    "id": "260122pyq1math6",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1mathsol6.png"
  },
  {
    "id": "260122pyq1math7",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1mathsol7.png"
  },
  {
    "id": "260122pyq1math8",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1mathsol8.png"
  },
  {
    "id": "260122pyq1math9",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1mathsol9.png"
  },
  {
    "id": "260122pyq1math10",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1mathsol10.png"
  },
  {
    "id": "260122pyq1math11",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1mathsol11.png"
  },
  {
    "id": "260122pyq1math12",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1mathsol12.png"
  },
  {
    "id": "260122pyq1math13",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1mathsol13.png"
  },
  {
    "id": "260122pyq1math14",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1mathsol14.png"
  },
  {
    "id": "260122pyq1math15",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1mathsol15.png"
  },
  {
    "id": "260122pyq1math16",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1mathsol16.png"
  },
  {
    "id": "260122pyq1math17",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1mathsol17.png"
  },
  {
    "id": "260122pyq1math18",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1mathsol18.png"
  },
  {
    "id": "260122pyq1math19",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1mathsol19.png"
  },
  {
    "id": "260122pyq1math20",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1mathsol20.png"
  },


  {
    "id": "260122pyq1phy1",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol1.png"
  },
  {
    "id": "260122pyq1phy2",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1physol2.png"
  },
  {
    "id": "260122pyq1phy3",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1physol3.png"
  },
  {
    "id": "260122pyq1phy4",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol4.png"
  },
  {
    "id": "260122pyq1phy5",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1physol5.png"
  },

  {
    "id": "260122pyq1phy6",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1physol6.png"
  },
  {
    "id": "260122pyq1phy7",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol7.png"
  },
  {
    "id": "260122pyq1phy8",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol8.png"
  },
  {
    "id": "260122pyq1phy9",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol9.png"
  },
  {
    "id": "260122pyq1phy10",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1physol10.png"
  },
  {
    "id": "260122pyq1phy11",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol11.png"
  },
  {
    "id": "260122pyq1phy12",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1physol12.png"
  },
  {
    "id": "260122pyq1phy13",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1physol13.png"
  },
  {
    "id": "260122pyq1phy14",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol14.png"
  },
  {
    "id": "260122pyq1phy15",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1physol15.png"
  },
  {
    "id": "260122pyq1phy16",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol16.png"
  },
  {
    "id": "260122pyq1phy17",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1physol17.png"
  },
  {
    "id": "260122pyq1phy18",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1physol18.png"
  },
  {
    "id": "260122pyq1phy19",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1physol19.png"
  },
  {
    "id": "260122pyq1phy20",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1physol20.png"
  },

  {
    "id": "260122pyq1che1",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1chesol1.png"
  },
  {
    "id": "260122pyq1che2",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1chesol2.png"
  },
  {
    "id": "260122pyq1che3",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1chesol3.png"
  },
  {
    "id": "260122pyq1che4",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1chesol4.png"
  },
  {
    "id": "260122pyq1che5",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1chesol5.png"
  },

  {
    "id": "260122pyq1che6",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1chesol6.png"
  },
  {
    "id": "260122pyq1che7",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1chesol7.png"
  },
  {
    "id": "260122pyq1che8",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1chesol8.png"
  },
  {
    "id": "260122pyq1che9",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1chesol9.png"
  },
  {
    "id": "260122pyq1che10",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1chesol10.png"
  },
  {
    "id": "260122pyq1che11",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1chesol11.png"
  },
  {
    "id": "260122pyq1che12",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1chesol12.png"
  },
  {
    "id": "260122pyq1che13",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq1chesol13.png"
  },
  {
    "id": "260122pyq1che14",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1chesol14.png"
  },
  {
    "id": "260122pyq1che15",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1chesol15.png"
  },
  {
    "id": "260122pyq1che16",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1chesol16.png"
  },
  {
    "id": "260122pyq1che17",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq1chesol17.png"
  },
  {
    "id": "260122pyq1che18",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1chesol18.png"
  },
  {
    "id": "260122pyq1che19",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq1chesol19.png"
  },
  {
    "id": "260122pyq1che80",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq1chesol20.png"
  },


    {
    "id": "260122pyq2math1",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2mathsol1.png"
  },
  {
    "id": "260122pyq2math2",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2mathsol2.png"
  },
  {
    "id": "260122pyq2math3",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2mathsol3.png"
  },
  {
    "id": "260122pyq2math4",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2mathsol4.png"
  },
  {
    "id": "260122pyq2math5",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2mathsol5.png"
  },

  {
    "id": "260122pyq2math6",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2mathsol6.png"
  },
  {
    "id": "260122pyq2math7",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2mathsol7.png"
  },
  {
    "id": "260122pyq2math8",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2mathsol8.png"
  },
  {
    "id": "260122pyq2math9",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2mathsol9.png"
  },
  {
    "id": "260122pyq2math10",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2mathsol10.png"
  },
  {
    "id": "260122pyq2math11",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2mathsol11.png"
  },
  {
    "id": "260122pyq2math12",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2mathsol12.png"
  },
  {
    "id": "260122pyq2math13",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2mathsol13.png"
  },
  {
    "id": "260122pyq2math14",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2mathsol14.png"
  },
  {
    "id": "260122pyq2math15",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2mathsol15.png"
  },
  {
    "id": "260122pyq2math16",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2mathsol16.png"
  },
  {
    "id": "260122pyq2math17",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2mathsol17.png"
  },
  {
    "id": "260122pyq2math18",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2mathsol18.png"
  },
  {
    "id": "260122pyq2math19",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2mathsol19.png"
  },
  {
    "id": "260122pyq2math20",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2mathsol20.png"
  },


  {
    "id": "260122pyq2phy1",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2physol1.png"
  },
  {
    "id": "260122pyq2phy2",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2physol2.png"
  },
  {
    "id": "260122pyq2phy3",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2physol3.png"
  },
  {
    "id": "260122pyq2phy4",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2physol4.png"
  },
  {
    "id": "260122pyq2phy5",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2physol5.png"
  },

  {
    "id": "260122pyq2phy6",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2physol6.png"
  },
  {
    "id": "260122pyq2phy7",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2physol7.png"
  },
  {
    "id": "260122pyq2phy8",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2physol8.png"
  },
  {
    "id": "260122pyq2phy9",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2physol9.png"
  },
  {
    "id": "260122pyq2phy10",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2physol10.png"
  },
  {
    "id": "260122pyq2phy11",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2physol11.png"
  },
  {
    "id": "260122pyq2phy12",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2physol12.png"
  },
  {
    "id": "260122pyq2phy13",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2physol13.png"
  },
  {
    "id": "260122pyq2phy14",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2physol14.png"
  },
  {
    "id": "260122pyq2phy15",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2physol15.png"
  },
  {
    "id": "260122pyq2phy16",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2physol16.png"
  },
  {
    "id": "260122pyq2phy17",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2physol17.png"
  },
  {
    "id": "260122pyq2phy18",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2physol18.png"
  },
  {
    "id": "260122pyq2phy19",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2physol19.png"
  },
  {
    "id": "260122pyq2phy20",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2physol20.png"
  },

  {
    "id": "260122pyq2che1",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2chesol1.png"
  },
  {
    "id": "260122pyq2che2",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2chesol2.png"
  },
  {
    "id": "260122pyq2che3",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2chesol3.png"
  },
  {
    "id": "260122pyq2che4",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol4.png"
  },
  {
    "id": "260122pyq2che5",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2chesol5.png"
  },

  {
    "id": "260122pyq2che6",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2chesol6.png"
  },
  {
    "id": "260122pyq2che7",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2chesol7.png"
  },
  {
    "id": "260122pyq2che8",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2chesol8.png"
  },
  {
    "id": "260122pyq2che9",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol9.png"
  },
  {
    "id": "260122pyq2che10",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol10.png"
  },
  {
    "id": "260122pyq2che11",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2chesol11.png"
  },
  {
    "id": "260122pyq2che12",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol12.png"
  },
  {
    "id": "260122pyq2che13",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol13.png"
  },
  {
    "id": "260122pyq2che14",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260122pyq2chesol14.png"
  },
  {
    "id": "260122pyq2che15",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol15.png"
  },
  {
    "id": "260122pyq2che16",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol16.png"
  },
  {
    "id": "260122pyq2che17",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260122pyq2chesol17.png"
  },
  {
    "id": "260122pyq2che18",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol18.png"
  },
  {
    "id": "260122pyq2che19",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260122pyq2chesol19.png"
  },
  {
    "id": "260122pyq2che80",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260122pyq2chesol20.png"
  },


    {
    "id": "260123pyq1math1",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1mathsol1.png"
  },
  {
    "id": "260123pyq1math2",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1mathsol2.png"
  },
  {
    "id": "260123pyq1math3",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1mathsol3.png"
  },
  {
    "id": "260123pyq1math4",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1mathsol4.png"
  },
  {
    "id": "260123pyq1math5",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1mathsol5.png"
  },

  {
    "id": "260123pyq1math6",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1mathsol6.png"
  },
  {
    "id": "260123pyq1math7",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1mathsol7.png"
  },
  {
    "id": "260123pyq1math8",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1mathsol8.png"
  },
  {
    "id": "260123pyq1math9",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1mathsol9.png"
  },
  {
    "id": "260123pyq1math10",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1mathsol10.png"
  },
  {
    "id": "260123pyq1math11",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1mathsol11.png"
  },
  {
    "id": "260123pyq1math12",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1mathsol12.png"
  },
  {
    "id": "260123pyq1math13",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1mathsol13.png"
  },
  {
    "id": "260123pyq1math14",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1mathsol14.png"
  },
  {
    "id": "260123pyq1math15",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1mathsol15.png"
  },
  {
    "id": "260123pyq1math16",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1mathsol16.png"
  },
  {
    "id": "260123pyq1math17",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1mathsol17.png"
  },
  {
    "id": "260123pyq1math18",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1mathsol18.png"
  },
  {
    "id": "260123pyq1math19",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1mathsol19.png"
  },
  {
    "id": "260123pyq1math20",
    "id_type": '260123pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1mathsol20.png"
  },


  {
    "id": "260123pyq1phy1",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1physol1.png"
  },
  {
    "id": "260123pyq1phy2",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1physol2.png"
  },
  {
    "id": "260123pyq1phy3",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1physol3.png"
  },
  {
    "id": "260123pyq1phy4",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1physol4.png"
  },
  {
    "id": "260123pyq1phy5",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1physol5.png"
  },

  {
    "id": "260123pyq1phy6",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1physol6.png"
  },
  {
    "id": "260123pyq1phy7",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1physol7.png"
  },
  {
    "id": "260123pyq1phy8",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1physol8.png"
  },
  {
    "id": "260123pyq1phy9",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1physol9.png"
  },
  {
    "id": "260123pyq1phy10",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1physol10.png"
  },
  {
    "id": "260123pyq1phy11",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1physol11.png"
  },
  {
    "id": "260123pyq1phy12",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1physol12.png"
  },
  {
    "id": "260123pyq1phy13",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1physol13.png"
  },
  {
    "id": "260123pyq1phy14",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1physol14.png"
  },
  {
    "id": "260123pyq1phy15",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1physol15.png"
  },
  {
    "id": "260123pyq1phy16",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1physol16.png"
  },
  {
    "id": "260123pyq1phy17",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1physol17.png"
  },
  {
    "id": "260123pyq1phy18",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1physol18.png"
  },
  {
    "id": "260123pyq1phy19",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1physol19.png"
  },
  {
    "id": "260123pyq1phy20",
    "id_type": '260123pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1physol20.png"
  },

  {
    "id": "260123pyq1che1",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol1.png"
  },
  {
    "id": "260123pyq1che2",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1chesol2.png"
  },
  {
    "id": "260123pyq1che3",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq1chesol3.png"
  },
  {
    "id": "260123pyq1che4",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol4.png"
  },
  {
    "id": "260123pyq1che5",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol5.png"
  },

  {
    "id": "260123pyq1che6",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol6.png"
  },
  {
    "id": "260123pyq1che7",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1chesol7.png"
  },
  {
    "id": "260123pyq1che8",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1chesol8.png"
  },
  {
    "id": "260123pyq1che9",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1chesol9.png"
  },
  {
    "id": "260123pyq1che10",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1chesol10.png"
  },
  {
    "id": "260123pyq1che11",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol11.png"
  },
  {
    "id": "260123pyq1che12",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol12.png"
  },
  {
    "id": "260123pyq1che13",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1chesol13.png"
  },
  {
    "id": "260123pyq1che14",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol14.png"
  },
  {
    "id": "260123pyq1che15",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1chesol15.png"
  },
  {
    "id": "260123pyq1che16",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1chesol16.png"
  },
  {
    "id": "260123pyq1che17",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol17.png"
  },
  {
    "id": "260123pyq1che18",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq1chesol18.png"
  },
  {
    "id": "260123pyq1che19",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq1chesol19.png"
  },
  {
    "id": "260123pyq1che80",
    "id_type": '260123pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq1chesol20.png"
  },



    {
    "id": "260123pyq2math1",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2mathsol1.png"
  },
  {
    "id": "260123pyq2math2",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2mathsol2.png"
  },
  {
    "id": "260123pyq2math3",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2mathsol3.png"
  },
  {
    "id": "260123pyq2math4",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2mathsol4.png"
  },
  {
    "id": "260123pyq2math5",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2mathsol5.png"
  },

  {
    "id": "260123pyq2math6",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2mathsol6.png"
  },
  {
    "id": "260123pyq2math7",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2mathsol7.png"
  },
  {
    "id": "260123pyq2math8",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2mathsol8.png"
  },
  {
    "id": "260123pyq2math9",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2mathsol9.png"
  },
  {
    "id": "260123pyq2math10",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2mathsol10.png"
  },
  {
    "id": "260123pyq2math11",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2mathsol11.png"
  },
  {
    "id": "260123pyq2math12",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2mathsol12.png"
  },
  {
    "id": "260123pyq2math13",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2mathsol13.png"
  },
  {
    "id": "260123pyq2math14",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2mathsol14.png"
  },
  {
    "id": "260123pyq2math15",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2mathsol15.png"
  },
  {
    "id": "260123pyq2math16",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2mathsol16.png"
  },
  {
    "id": "260123pyq2math17",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2mathsol17.png"
  },
  {
    "id": "260123pyq2math18",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2mathsol18.png"
  },
  {
    "id": "260123pyq2math19",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2mathsol19.png"
  },
  {
    "id": "260123pyq2math20",
    "id_type": '260123pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260123pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2mathsol20.png"
  },


  {
    "id": "260123pyq2phy1",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2physol1.png"
  },
  {
    "id": "260123pyq2phy2",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2physol2.png"
  },
  {
    "id": "260123pyq2phy3",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2physol3.png"
  },
  {
    "id": "260123pyq2phy4",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2physol4.png"
  },
  {
    "id": "260123pyq2phy5",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2physol5.png"
  },

  {
    "id": "260123pyq2phy6",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2physol6.png"
  },
  {
    "id": "260123pyq2phy7",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2physol7.png"
  },
  {
    "id": "260123pyq2phy8",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2physol8.png"
  },
  {
    "id": "260123pyq2phy9",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2physol9.png"
  },
  {
    "id": "260123pyq2phy10",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2physol10.png"
  },
  {
    "id": "260123pyq2phy11",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2physol11.png"
  },
  {
    "id": "260123pyq2phy12",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2physol12.png"
  },
  {
    "id": "260123pyq2phy13",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2physol13.png"
  },
  {
    "id": "260123pyq2phy14",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2physol14.png"
  },
  {
    "id": "260123pyq2phy15",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques15.png",
    "option1": "( 1, 3, 4 )",
    "option2": "( 2, 4,3 )",
    "option3": "( 3, 2, 1 )",
    "option4": "( 1, 2, 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2physol15.png"
  },
  {
    "id": "260123pyq2phy16",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2physol16.png"
  },
  {
    "id": "260123pyq2phy17",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2physol17.png"
  },
  {
    "id": "260123pyq2phy18",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2physol18.png"
  },
  {
    "id": "260123pyq2phy19",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2physol19.png"
  },
  {
    "id": "260123pyq2phy20",
    "id_type": '260123pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260123pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2physol20.png"
  },

  {
    "id": "260123pyq2che1",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2chesol1.png"
  },
  {
    "id": "260123pyq2che2",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2chesol2.png"
  },
  {
    "id": "260123pyq2che3",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2chesol3.png"
  },
  {
    "id": "260123pyq2che4",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2chesol4.png"
  },
  {
    "id": "260123pyq2che5",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2chesol5.png"
  },

  {
    "id": "260123pyq2che6",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2chesol6.png"
  },
  {
    "id": "260123pyq2che7",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2chesol7.png"
  },
  {
    "id": "260123pyq2che8",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2chesol8.png"
  },
  {
    "id": "260123pyq2che9",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2chesol9.png"
  },
  {
    "id": "260123pyq2che10",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2chesol10.png"
  },
  {
    "id": "260123pyq2che11",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2chesol11.png"
  },
  {
    "id": "260123pyq2che12",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2chesol12.png"
  },
  {
    "id": "260123pyq2che13",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2chesol13.png"
  },
  {
    "id": "260123pyq2che14",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2chesol14.png"
  },
  {
    "id": "260123pyq2che15",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2chesol15.png"
  },
  {
    "id": "260123pyq2che16",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260123pyq2chesol16.png"
  },
  {
    "id": "260123pyq2che17",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2chesol17.png"
  },
  {
    "id": "260123pyq2che18",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260123pyq2chesol18.png"
  },
  {
    "id": "260123pyq2che19",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260123pyq2chesol19.png"
  },
  {
    "id": "260123pyq2che80",
    "id_type": '260123pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260123pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260123pyq2chesol20.png"
  },


  
  {
    "id": "260124pyq1math1",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1mathsol1.png"
  },
  {
    "id": "260124pyq1math2",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1mathsol2.png"
  },
  {
    "id": "260124pyq1math3",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq1mathsol3.png"
  },
  {
    "id": "260124pyq1math4",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1mathsol4.png"
  },
  {
    "id": "260124pyq1math5",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1mathsol5.png"
  },

  {
    "id": "260124pyq1math6",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1mathsol6.png"
  },
  {
    "id": "260124pyq1math7",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq1mathsol7.png"
  },
  {
    "id": "260124pyq1math8",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1mathsol8.png"
  },
  {
    "id": "260124pyq1math9",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1mathsol9.png"
  },
  {
    "id": "260124pyq1math10",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1mathsol10.png"
  },
  {
    "id": "260124pyq1math11",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1mathsol11.png"
  },
  {
    "id": "260124pyq1math12",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1mathsol12.png"
  },
  {
    "id": "260124pyq1math13",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1mathsol13.png"
  },
  {
    "id": "260124pyq1math14",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1mathsol14.png"
  },
  {
    "id": "260124pyq1math15",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1mathsol15.png"
  },
  {
    "id": "260124pyq1math16",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq1mathsol16.png"
  },
  {
    "id": "260124pyq1math17",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1mathsol17.png"
  },
  {
    "id": "260124pyq1math18",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1mathsol18.png"
  },
  {
    "id": "260124pyq1math19",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1mathsol19.png"
  },
  {
    "id": "260124pyq1math20",
    "id_type": '260124pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1mathsol20.png"
  },


  {
    "id": "260124pyq1phy1",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1physol1.png"
  },
  {
    "id": "260124pyq1phy2",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1physol2.png"
  },
  {
    "id": "260124pyq1phy3",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1physol3.png"
  },
  {
    "id": "260124pyq1phy4",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1physol4.png"
  },
  {
    "id": "260124pyq1phy5",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1physol5.png"
  },

  {
    "id": "260124pyq1phy6",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1physol6.png"
  },
  {
    "id": "260124pyq1phy7",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1physol7.png"
  },
  {
    "id": "260124pyq1phy8",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1physol8.png"
  },
  {
    "id": "260124pyq1phy9",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1physol9.png"
  },
  {
    "id": "260124pyq1phy10",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1physol10.png"
  },
  {
    "id": "260124pyq1phy11",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1physol11.png"
  },
  {
    "id": "260124pyq1phy12",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq1physol12.png"
  },
  {
    "id": "260124pyq1phy13",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1physol13.png"
  },
  {
    "id": "260124pyq1phy14",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq1physol14.png"
  },
  {
    "id": "260124pyq1phy15",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1physol15.png"
  },
  {
    "id": "260124pyq1phy16",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1physol16.png"
  },
  {
    "id": "260124pyq1phy17",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1physol17.png"
  },
  {
    "id": "260124pyq1phy18",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1physol18.png"
  },
  {
    "id": "260124pyq1phy19",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1physol19.png"
  },
  {
    "id": "260124pyq1phy20",
    "id_type": '260124pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1physol20.png"
  },

  {
    "id": "260124pyq1che1",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1chesol1.png"
  },
  {
    "id": "260124pyq1che2",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1chesol2.png"
  },
  {
    "id": "260124pyq1che3",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1chesol3.png"
  },
  {
    "id": "260124pyq1che4",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq1chesol4.png"
  },
  {
    "id": "260124pyq1che5",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq1chesol5.png"
  },

  {
    "id": "260124pyq1che6",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1chesol6.png"
  },
  {
    "id": "260124pyq1che7",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1chesol7.png"
  },
  {
    "id": "260124pyq1che8",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1chesol8.png"
  },
  {
    "id": "260124pyq1che9",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1chesol9.png"
  },
  {
    "id": "260124pyq1che10",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1chesol10.png"
  },
  {
    "id": "260124pyq1che11",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1chesol11.png"
  },
  {
    "id": "260124pyq1che12",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq1chesol12.png"
  },
  {
    "id": "260124pyq1che13",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1chesol13.png"
  },
  {
    "id": "260124pyq1che14",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1chesol14.png"
  },
  {
    "id": "260124pyq1che15",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1chesol15.png"
  },
  {
    "id": "260124pyq1che16",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq1chesol16.png"
  },
  {
    "id": "260124pyq1che17",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1chesol17.png"
  },
  {
    "id": "260124pyq1che18",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1chesol18.png"
  },
  {
    "id": "260124pyq1che19",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq1chesol19.png"
  },
  {
    "id": "260124pyq1che80",
    "id_type": '260124pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq1chesol20.png"
  },


  
  {
    "id": "260124pyq2math1",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2mathsol1.png"
  },
  {
    "id": "260124pyq2math2",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2mathsol2.png"
  },
  {
    "id": "260124pyq2math3",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2mathsol3.png"
  },
  {
    "id": "260124pyq2math4",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "optio3",
    "solution_img": "260124pyq2mathsol4.png"
  },
  {
    "id": "260124pyq2math5",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2mathsol5.png"
  },

  {
    "id": "260124pyq2math6",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2mathsol6.png"
  },
  {
    "id": "260124pyq2math7",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2mathsol7.png"
  },
  {
    "id": "260124pyq2math8",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2mathsol8.png"
  },
  {
    "id": "260124pyq2math9",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2mathsol9.png"
  },
  {
    "id": "260124pyq2math10",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2mathsol10.png"
  },
  {
    "id": "260124pyq2math11",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2mathsol11.png"
  },
  {
    "id": "260124pyq2math12",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2mathsol12.png"
  },
  {
    "id": "260124pyq2math13",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2mathsol13.png"
  },
  {
    "id": "260124pyq2math14",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2mathsol14.png"
  },
  {
    "id": "260124pyq2math15",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2mathsol15.png"
  },
  {
    "id": "260124pyq2math16",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2mathsol16.png"
  },
  {
    "id": "260124pyq2math17",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2mathsol17.png"
  },
  {
    "id": "260124pyq2math18",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2mathsol18.png"
  },
  {
    "id": "260124pyq2math19",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2mathsol19.png"
  },
  {
    "id": "260124pyq2math20",
    "id_type": '260124pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260124pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2mathsol20.png"
  },


  {
    "id": "260124pyq2phy1",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2physol1.png"
  },
  {
    "id": "260124pyq2phy2",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2physol2.png"
  },
  {
    "id": "260124pyq2phy3",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2physol3.png"
  },
  {
    "id": "260124pyq2phy4",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2physol4.png"
  },
  {
    "id": "260124pyq2phy5",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2physol5.png"
  },

  {
    "id": "260124pyq2phy6",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol6.png"
  },
  {
    "id": "260124pyq2phy7",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol7.png"
  },
  {
    "id": "260124pyq2phy8",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol8.png"
  },
  {
    "id": "260124pyq2phy9",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2physol9.png"
  },
  {
    "id": "260124pyq2phy10",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol10.png"
  },
  {
    "id": "260124pyq2phy11",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2physol11.png"
  },
  {
    "id": "260124pyq2phy12",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol12.png"
  },
  {
    "id": "260124pyq2phy13",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2physol13.png"
  },
  {
    "id": "260124pyq2phy14",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol14.png"
  },
  {
    "id": "260124pyq2phy15",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2physol15.png"
  },
  {
    "id": "260124pyq2phy16",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol16.png"
  },
  {
    "id": "260124pyq2phy17",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2physol17.png"
  },
  {
    "id": "260124pyq2phy18",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol18.png"
  },
  {
    "id": "260124pyq2phy19",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2physol19.png"
  },
  {
    "id": "260124pyq2phy20",
    "id_type": '260124pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260124pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2physol20.png"
  },

  {
    "id": "260124pyq2che1",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2chesol1.png"
  },
  {
    "id": "260124pyq2che2",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2chesol2.png"
  },
  {
    "id": "260124pyq2che3",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2chesol3.png"
  },
  {
    "id": "260124pyq2che4",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2chesol4.png"
  },
  {
    "id": "260124pyq2che5",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2chesol5.png"
  },

  {
    "id": "260124pyq2che6",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2chesol6.png"
  },
  {
    "id": "260124pyq2che7",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2chesol7.png"
  },
  {
    "id": "260124pyq2che8",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2chesol8.png"
  },
  {
    "id": "260124pyq2che9",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2chesol9.png"
  },
  {
    "id": "260124pyq2che10",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2chesol10.png"
  },
  {
    "id": "260124pyq2che11",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2chesol11.png"
  },
  {
    "id": "260124pyq2che12",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260124pyq2chesol12.png"
  },
  {
    "id": "260124pyq2che13",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2chesol13.png"
  },
  {
    "id": "260124pyq2che14",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2chesol14.png"
  },
  {
    "id": "260124pyq2che15",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2chesol15.png"
  },
  {
    "id": "260124pyq2che16",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2chesol16.png"
  },
  {
    "id": "260124pyq2che17",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260124pyq2chesol17.png"
  },
  {
    "id": "260124pyq2che18",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2chesol18.png"
  },
  {
    "id": "260124pyq2che19",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260124pyq2chesol19.png"
  },
  {
    "id": "260124pyq2che80",
    "id_type": '260124pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260124pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260124pyq2chesol20.png"
  },


  
  {
    "id": "260128pyq1math1",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1mathsol1.png"
  },
  {
    "id": "260128pyq1math2",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1mathsol2.png"
  },
  {
    "id": "260128pyq1math3",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1mathsol3.png"
  },
  {
    "id": "260128pyq1math4",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1mathsol4.png"
  },
  {
    "id": "260128pyq1math5",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1mathsol5.png"
  },

  {
    "id": "260128pyq1math6",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1mathsol6.png"
  },
  {
    "id": "260128pyq1math7",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1mathsol7.png"
  },
  {
    "id": "260128pyq1math8",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1mathsol8.png"
  },
  {
    "id": "260128pyq1math9",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1mathsol9.png"
  },
  {
    "id": "260128pyq1math10",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1mathsol10.png"
  },
  {
    "id": "260128pyq1math11",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1mathsol11.png"
  },
  {
    "id": "260128pyq1math12",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1mathsol12.png"
  },
  {
    "id": "260128pyq1math13",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1mathsol13.png"
  },
  {
    "id": "260128pyq1math14",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1mathsol14.png"
  },
  {
    "id": "260128pyq1math15",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1mathsol15.png"
  },
  {
    "id": "260128pyq1math16",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1mathsol16.png"
  },
  {
    "id": "260128pyq1math17",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1mathsol17.png"
  },
  {
    "id": "260128pyq1math18",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1mathsol18.png"
  },
  {
    "id": "260128pyq1math19",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1mathsol19.png"
  },
  {
    "id": "260128pyq1math20",
    "id_type": '260128pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1mathsol20.png"
  },


  {
    "id": "260128pyq1phy1",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1physol1.png"
  },
  {
    "id": "260128pyq1phy2",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1physol2.png"
  },
  {
    "id": "260128pyq1phy3",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1physol3.png"
  },
  {
    "id": "260128pyq1phy4",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1physol4.png"
  },
  {
    "id": "260128pyq1phy5",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1physol5.png"
  },
  {
    "id": "260128pyq1phy6",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1physol6.png"
  },
  {
    "id": "260128pyq1phy7",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1physol7.png"
  },
  {
    "id": "260128pyq1phy8",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1physol8.png"
  },
  {
    "id": "260128pyq1phy9",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1physol9.png"
  },
  {
    "id": "260128pyq1phy10",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1physol10.png"
  },
  {
    "id": "260128pyq1phy11",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1physol11.png"
  },
  {
    "id": "260128pyq1phy12",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1physol12.png"
  },
  {
    "id": "260128pyq1phy13",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1physol13.png"
  },
  {
    "id": "260128pyq1phy14",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1physol14.png"
  },
  {
    "id": "260128pyq1phy15",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1physol15.png"
  },
  {
    "id": "260128pyq1phy16",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1physol16.png"
  },
  {
    "id": "260128pyq1phy17",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1physol17.png"
  },
  {
    "id": "260128pyq1phy18",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1physol18.png"
  },
  {
    "id": "260128pyq1phy19",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1physol19.png"
  },
  {
    "id": "260128pyq1phy20",
    "id_type": '260128pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1physol20.png"
  },

  {
    "id": "260128pyq1che1",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1chesol1.png"
  },
  {
    "id": "260128pyq1che2",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1chesol2.png"
  },
  {
    "id": "260128pyq1che3",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1chesol3.png"
  },
  {
    "id": "260128pyq1che4",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1chesol4.png"
  },
  {
    "id": "260128pyq1che5",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1chesol5.png"
  },

  {
    "id": "260128pyq1che6",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1chesol6.png"
  },
  {
    "id": "260128pyq1che7",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1chesol7.png"
  },
  {
    "id": "260128pyq1che8",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1chesol8.png"
  },
  {
    "id": "260128pyq1che9",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1chesol9.png"
  },
  {
    "id": "260128pyq1che10",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1chesol10.png"
  },
  {
    "id": "260128pyq1che11",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1chesol11.png"
  },
  {
    "id": "260128pyq1che12",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq1chesol12.png"
  },
  {
    "id": "260128pyq1che13",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1chesol13.png"
  },
  {
    "id": "260128pyq1che14",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1chesol14.png"
  },
  {
    "id": "260128pyq1che15",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq1chesol15.png"
  },
  {
    "id": "260128pyq1che16",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1chesol16.png"
  },
  {
    "id": "260128pyq1che17",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq1chesol17.png"
  },
  {
    "id": "260128pyq1che18",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1chesol18.png"
  },
  {
    "id": "260128pyq1che19",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1chesol19.png"
  },
  {
    "id": "260128pyq1che80",
    "id_type": '260128pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq1chesol20.png"
  },


    {
    "id": "260128pyq2math1",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol1.png"
  },
  {
    "id": "260128pyq2math2",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol2.png"
  },
  {
    "id": "260128pyq2math3",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol3.png"
  },
  {
    "id": "260128pyq2math4",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2mathsol4.png"
  },
  {
    "id": "260128pyq2math5",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2mathsol5.png"
  },

  {
    "id": "260128pyq2math6",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol6.png"
  },
  {
    "id": "260128pyq2math7",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2mathsol7.png"
  },
  {
    "id": "260128pyq2math8",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol8.png"
  },
  {
    "id": "260128pyq2math9",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol9.png"
  },
  {
    "id": "260128pyq2math10",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2mathsol10.png"
  },
  {
    "id": "260128pyq2math11",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2mathsol11.png"
  },
  {
    "id": "260128pyq2math12",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2mathsol12.png"
  },
  {
    "id": "260128pyq2math13",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol13.png"
  },
  {
    "id": "260128pyq2math14",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2mathsol14.png"
  },
  {
    "id": "260128pyq2math15",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol15.png"
  },
  {
    "id": "260128pyq2math16",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2mathsol16.png"
  },
  {
    "id": "260128pyq2math17",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2mathsol17.png"
  },
  {
    "id": "260128pyq2math18",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2mathsol18.png"
  },
  {
    "id": "260128pyq2math19",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2mathsol19.png"
  },
  {
    "id": "260128pyq2math20",
    "id_type": '260128pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260128pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2mathsol20.png"
  },


  {
    "id": "260128pyq2phy1",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2physol1.png"
  },
  {
    "id": "260128pyq2phy2",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2physol2.png"
  },
  {
    "id": "260128pyq2phy3",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2physol3.png"
  },
  {
    "id": "260128pyq2phy4",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2physol4.png"
  },
  {
    "id": "260128pyq2phy5",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2physol5.png"
  },
  {
    "id": "260128pyq2phy6",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2physol6.png"
  },
  {
    "id": "260128pyq2phy7",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2physol7.png"
  },
  {
    "id": "260128pyq2phy8",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2physol8.png"
  },
  {
    "id": "260128pyq2phy9",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2physol9.png"
  },
  {
    "id": "260128pyq2phy10",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2physol10.png"
  },
  {
    "id": "260128pyq2phy11",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2physol11.png"
  },
  {
    "id": "260128pyq2phy12",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2physol12.png"
  },
  {
    "id": "260128pyq2phy13",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2physol13.png"
  },
  {
    "id": "260128pyq2phy14",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2physol14.png"
  },
  {
    "id": "260128pyq2phy15",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2physol15.png"
  },
  {
    "id": "260128pyq2phy16",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2physol16.png"
  },
  {
    "id": "260128pyq2phy17",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2physol17.png"
  },
  {
    "id": "260128pyq2phy18",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2physol18.png"
  },
  {
    "id": "260128pyq2phy19",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2physol19.png"
  },
  {
    "id": "260128pyq2phy20",
    "id_type": '260128pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260128pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2physol20.png"
  },

  {
    "id": "260128pyq2che1",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2chesol1.png"
  },
  {
    "id": "260128pyq2che2",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2chesol2.png"
  },
  {
    "id": "260128pyq2che3",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2chesol3.png"
  },
  {
    "id": "260128pyq2che4",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2chesol4.png"
  },
  {
    "id": "260128pyq2che5",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2chesol5.png"
  },

  {
    "id": "260128pyq2che6",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2chesol6.png"
  },
  {
    "id": "260128pyq2che7",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2chesol7.png"
  },
  {
    "id": "260128pyq2che8",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2chesol8.png"
  },
  {
    "id": "260128pyq2che9",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2chesol9.png"
  },
  {
    "id": "260128pyq2che10",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2chesol10.png"
  },
  {
    "id": "260128pyq2che11",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2chesol11.png"
  },
  {
    "id": "260128pyq2che12",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2chesol12.png"
  },
  {
    "id": "260128pyq2che13",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2chesol13.png"
  },
  {
    "id": "260128pyq2che14",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2chesol14.png"
  },
  {
    "id": "260128pyq2che15",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2chesol15.png"
  },
  {
    "id": "260128pyq2che16",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2chesol16.png"
  },
  {
    "id": "260128pyq2che17",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260128pyq2chesol17.png"
  },
  {
    "id": "260128pyq2che18",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260128pyq2chesol18.png"
  },
  {
    "id": "260128pyq2che19",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260128pyq2chesol19.png"
  },
  {
    "id": "260128pyq2che80",
    "id_type": '260128pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260128pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260128pyq2chesol20.png"
  },





  {
    "id": "260402pyq1math1",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol1.png"
  },
  {
    "id": "260402pyq1math2",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1mathsol2.png"
  },
  {
    "id": "260402pyq1math3",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol3.png"
  },
  {
    "id": "260402pyq1math4",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol4.png"
  },
  {
    "id": "260402pyq1math5",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol5.png"
  },

  {
    "id": "260402pyq1math6",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol6.png"
  },
  {
    "id": "260402pyq1math7",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol7.png"
  },
  {
    "id": "260402pyq1math8",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol8.png"
  },
  {
    "id": "260402pyq1math9",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol9.png"
  },
  {
    "id": "260402pyq1math10",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1mathsol10.png"
  },
  {
    "id": "260402pyq1math11",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1mathsol11.png"
  },
  {
    "id": "260402pyq1math12",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1mathsol12.png"
  },
  {
    "id": "260402pyq1math13",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol13.png"
  },
  {
    "id": "260402pyq1math14",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol14.png"
  },
  {
    "id": "260402pyq1math15",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol15.png"
  },
  {
    "id": "260402pyq1math16",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol16.png"
  },
  {
    "id": "260402pyq1math17",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol17.png"
  },
  {
    "id": "260402pyq1math18",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol18.png"
  },
  {
    "id": "260402pyq1math19",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol19.png"
  },
  {
    "id": "260402pyq1math20",
    "id_type": '260402pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1mathsol20.png"
  },


  {
    "id": "260402pyq1phy1",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol1.png"
  },
  {
    "id": "260402pyq1phy2",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol2.png"
  },
  {
    "id": "260402pyq1phy3",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol3.png"
  },
  {
    "id": "260402pyq1phy4",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1physol4.png"
  },
  {
    "id": "260402pyq1phy5",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol5.png"
  },

  {
    "id": "260402pyq1phy6",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1physol6.png"
  },
  {
    "id": "260402pyq1phy7",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol7.png"
  },
  {
    "id": "260402pyq1phy8",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1physol8.png"
  },
  {
    "id": "260402pyq1phy9",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1physol9.png"
  },
  {
    "id": "260402pyq1phy10",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1physol10.png"
  },
  {
    "id": "260402pyq1phy11",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol11.png"
  },
  {
    "id": "260402pyq1phy12",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol12.png"
  },
  {
    "id": "260402pyq1phy13",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol13.png"
  },
  {
    "id": "260402pyq1phy14",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol14.png"
  },
  {
    "id": "260402pyq1phy15",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol15.png"
  },
  {
    "id": "260402pyq1phy16",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol16.png"
  },
  {
    "id": "260402pyq1phy17",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol17.png"
  },
  {
    "id": "260402pyq1phy18",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol18.png"
  },
  {
    "id": "260402pyq1phy19",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1physol19.png"
  },
  {
    "id": "260402pyq1phy20",
    "id_type": '260402pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol20.png"
  },

  {
    "id": "260402pyq1che1",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol1.png"
  },
  {
    "id": "260402pyq1che2",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol2.png"
  },
  {
    "id": "260402pyq1che3",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol3.png"
  },
  {
    "id": "260402pyq1che4",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol4.png"
  },
  {
    "id": "260402pyq1che5",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol5.png"
  },

  {
    "id": "260402pyq1che6",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol6.png"
  },
  {
    "id": "260402pyq1che7",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol7.png"
  },
  {
    "id": "260402pyq1che8",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1chesol8.png"
  },
  {
    "id": "260402pyq1che9",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol9.png"
  },
  {
    "id": "260402pyq1che10",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol10.png"
  },
  {
    "id": "260402pyq1che11",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol11.png"
  },
  {
    "id": "260402pyq1che12",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol12.png"
  },
  {
    "id": "260402pyq1che13",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol13.png"
  },
  {
    "id": "260402pyq1che14",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol14.png"
  },
  {
    "id": "260402pyq1che15",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol15.png"
  },
  {
    "id": "260402pyq1che16",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol16.png"
  },
  {
    "id": "260402pyq1che17",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol17.png"
  },
  {
    "id": "260402pyq1che18",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol18.png"
  },
  {
    "id": "260402pyq1che19",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol19.png"
  },
  {
    "id": "260402pyq1che80",
    "id_type": '260402pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1chesol20.png"
  },


    {
    "id": "260402pyq2math1",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1mathsol1.png"
  },
  {
    "id": "260402pyq2math2",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol2.png"
  },
  {
    "id": "260402pyq2math3",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol3.png"
  },
  {
    "id": "260402pyq2math4",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1mathsol4.png"
  },
  {
    "id": "260402pyq2math5",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol5.png"
  },

  {
    "id": "260402pyq2math6",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol6.png"
  },
  {
    "id": "260402pyq2math7",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol7.png"
  },
  {
    "id": "260402pyq2math8",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol8.png"
  },
  {
    "id": "260402pyq2math9",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1mathsol9.png"
  },
  {
    "id": "260402pyq2math10",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol10.png"
  },
  {
    "id": "260402pyq2math11",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol11.png"
  },
  {
    "id": "260402pyq2math12",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol12.png"
  },
  {
    "id": "260402pyq2math13",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1mathsol13.png"
  },
  {
    "id": "260402pyq2math14",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol14.png"
  },
  {
    "id": "260402pyq2math15",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1mathsol15.png"
  },
  {
    "id": "260402pyq2math16",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol16.png"
  },
  {
    "id": "260402pyq2math17",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol17.png"
  },
  {
    "id": "260402pyq2math18",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1mathsol18.png"
  },
  {
    "id": "260402pyq2math19",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1mathsol19.png"
  },
  {
    "id": "260402pyq2math20",
    "id_type": '260402pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260402pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1mathsol20.png"
  },


  {
    "id": "260402pyq2phy1",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol1.png"
  },
  {
    "id": "260402pyq2phy2",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol2.png"
  },
  {
    "id": "260402pyq2phy3",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1physol3.png"
  },
  {
    "id": "260402pyq2phy4",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol4.png"
  },
  {
    "id": "260402pyq2phy5",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1physol5.png"
  },

  {
    "id": "260402pyq2phy6",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol6.png"
  },
  {
    "id": "260402pyq2phy7",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol7.png"
  },
  {
    "id": "260402pyq2phy8",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1physol8.png"
  },
  {
    "id": "260402pyq2phy9",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1physol9.png"
  },
  {
    "id": "260402pyq2phy10",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol10.png"
  },
  {
    "id": "260402pyq2phy11",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol11.png"
  },
  {
    "id": "260402pyq2phy12",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol12.png"
  },
  {
    "id": "260402pyq2phy13",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol13.png"
  },
  {
    "id": "260402pyq2phy14",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol14.png"
  },
  {
    "id": "260402pyq2phy15",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1physol15.png"
  },
  {
    "id": "260402pyq2phy16",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1physol16.png"
  },
  {
    "id": "260402pyq2phy17",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol17.png"
  },
  {
    "id": "260402pyq2phy18",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1physol18.png"
  },
  {
    "id": "260402pyq2phy19",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1physol19.png"
  },
  {
    "id": "260402pyq2phy20",
    "id_type": '260402pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260402pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1physol20.png"
  },

  {
    "id": "260402pyq2che1",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1chesol1.png"
  },
  {
    "id": "260402pyq2che2",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol2.png"
  },
  {
    "id": "260402pyq2che3",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1chesol3.png"
  },
  {
    "id": "260402pyq2che4",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol4.png"
  },
  {
    "id": "260402pyq2che5",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol5.png"
  },

  {
    "id": "260402pyq2che6",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1chesol6.png"
  },
  {
    "id": "260402pyq2che7",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol7.png"
  },
  {
    "id": "260402pyq2che8",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol8.png"
  },
  {
    "id": "260402pyq2che9",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1chesol9.png"
  },
  {
    "id": "260402pyq2che10",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol10.png"
  },
  {
    "id": "260402pyq2che11",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1chesol11.png"
  },
  {
    "id": "260402pyq2che12",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol12.png"
  },
  {
    "id": "260402pyq2che13",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260402pyq1chesol13.png"
  },
  {
    "id": "260402pyq2che14",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol14.png"
  },
  {
    "id": "260402pyq2che15",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol15.png"
  },
  {
    "id": "260402pyq2che16",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol16.png"
  },
  {
    "id": "260402pyq2che17",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol17.png"
  },
  {
    "id": "260402pyq2che18",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260402pyq1chesol18.png"
  },
  {
    "id": "260402pyq2che19",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260402pyq1chesol19.png"
  },
  {
    "id": "260402pyq2che80",
    "id_type": '260402pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260402pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260402pyq1chesol20.png"
  },

  {
    "id": "260404pyq1math1",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1mathsol1.png"
  },
  {
    "id": "260404pyq1math2",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1mathsol2.png"
  },
  {
    "id": "260404pyq1math3",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1mathsol3.png"
  },
  {
    "id": "260404pyq1math4",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1mathsol4.png"
  },
  {
    "id": "260404pyq1math5",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1mathsol5.png"
  },

  {
    "id": "260404pyq1math6",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1mathsol6.png"
  },
  {
    "id": "260404pyq1math7",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1mathsol7.png"
  },
  {
    "id": "260404pyq1math8",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1mathsol8.png"
  },
  {
    "id": "260404pyq1math9",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1mathsol9.png"
  },
  {
    "id": "260404pyq1math10",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1mathsol10.png"
  },
  {
    "id": "260404pyq1math11",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1mathsol11.png"
  },
  {
    "id": "260404pyq1math12",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1mathsol12.png"
  },
  {
    "id": "260404pyq1math13",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1mathsol13.png"
  },
  {
    "id": "260404pyq1math14",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1mathsol14.png"
  },
  {
    "id": "260404pyq1math15",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1mathsol15.png"
  },
  {
    "id": "260404pyq1math16",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1mathsol16.png"
  },
  {
    "id": "260404pyq1math17",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1mathsol17.png"
  },
  {
    "id": "260404pyq1math18",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1mathsol18.png"
  },
  {
    "id": "260404pyq1math19",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1mathsol19.png"
  },
  {
    "id": "260404pyq1math20",
    "id_type": '260404pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1mathsol20.png"
  },


  {
    "id": "260404pyq1phy1",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1physol1.png"
  },
  {
    "id": "260404pyq1phy2",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol2.png"
  },
  {
    "id": "260404pyq1phy3",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1physol3.png"
  },
  {
    "id": "260404pyq1phy4",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1physol4.png"
  },
  {
    "id": "260404pyq1phy5",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol5.png"
  },

  {
    "id": "260404pyq1phy6",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol6.png"
  },
  {
    "id": "260404pyq1phy7",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1physol7.png"
  },
  {
    "id": "260404pyq1phy8",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1physol8.png"
  },
  {
    "id": "260404pyq1phy9",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol9.png"
  },
  {
    "id": "260404pyq1phy10",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol10.png"
  },
  {
    "id": "260404pyq1phy11",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol11.png"
  },
  {
    "id": "260404pyq1phy12",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1physol12.png"
  },
  {
    "id": "260404pyq1phy13",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1physol13.png"
  },
  {
    "id": "260404pyq1phy14",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol14.png"
  },
  {
    "id": "260404pyq1phy15",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1physol15.png"
  },
  {
    "id": "260404pyq1phy16",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol16.png"
  },
  {
    "id": "260404pyq1phy17",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1physol17.png"
  },
  {
    "id": "260404pyq1phy18",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol18.png"
  },
  {
    "id": "260404pyq1phy19",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1physol19.png"
  },
  {
    "id": "260404pyq1phy20",
    "id_type": '260404pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1physol20.png"
  },

  {
    "id": "260404pyq1che1",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1chesol1.png"
  },
  {
    "id": "260404pyq1che2",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1chesol2.png"
  },
  {
    "id": "260404pyq1che3",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1chesol3.png"
  },
  {
    "id": "260404pyq1che4",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1chesol4.png"
  },
  {
    "id": "260404pyq1che5",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1chesol5.png"
  },

  {
    "id": "260404pyq1che6",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1chesol6.png"
  },
  {
    "id": "260404pyq1che7",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1chesol7.png"
  },
  {
    "id": "260404pyq1che8",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1chesol8.png"
  },
  {
    "id": "260404pyq1che9",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1chesol9.png"
  },
  {
    "id": "260404pyq1che10",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1chesol10.png"
  },
  {
    "id": "260404pyq1che11",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1chesol11.png"
  },
  {
    "id": "260404pyq1che12",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1chesol12.png"
  },
  {
    "id": "260404pyq1che13",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq1chesol13.png"
  },
  {
    "id": "260404pyq1che14",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1chesol14.png"
  },
  {
    "id": "260404pyq1che15",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1chesol15.png"
  },
  {
    "id": "260404pyq1che16",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1chesol16.png"
  },
  {
    "id": "260404pyq1che17",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq1chesol17.png"
  },
  {
    "id": "260404pyq1che18",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1chesol18.png"
  },
  {
    "id": "260404pyq1che19",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq1chesol19.png"
  },
  {
    "id": "260404pyq1che80",
    "id_type": '260404pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq1chesol20.png"
  },

  {
    "id": "260404pyq2math1",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2mathsol1.png"
  },
  {
    "id": "260404pyq2math2",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2mathsol2.png"
  },
  {
    "id": "260404pyq2math3",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2mathsol3.png"
  },
  {
    "id": "260404pyq2math4",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2mathsol4.png"
  },
  {
    "id": "260404pyq2math5",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2mathsol5.png"
  },

  {
    "id": "260404pyq2math6",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2mathsol6.png"
  },
  {
    "id": "260404pyq2math7",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2mathsol7.png"
  },
  {
    "id": "260404pyq2math8",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2mathsol8.png"
  },
  {
    "id": "260404pyq2math9",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2mathsol9.png"
  },
  {
    "id": "260404pyq2math10",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2mathsol10.png"
  },
  {
    "id": "260404pyq2math11",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2mathsol11.png"
  },
  {
    "id": "260404pyq2math12",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2mathsol12.png"
  },
  {
    "id": "260404pyq2math13",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2mathsol13.png"
  },
  {
    "id": "260404pyq2math14",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2mathsol14.png"
  },
  {
    "id": "260404pyq2math15",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2mathsol15.png"
  },
  {
    "id": "260404pyq2math16",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2mathsol16.png"
  },
  {
    "id": "260404pyq2math17",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2mathsol17.png"
  },
  {
    "id": "260404pyq2math18",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2mathsol18.png"
  },
  {
    "id": "260404pyq2math19",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2mathsol19.png"
  },
  {
    "id": "260404pyq2math20",
    "id_type": '260404pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260404pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2mathsol20.png"
  },


  {
    "id": "260404pyq2phy1",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2physol1.png"
  },
  {
    "id": "260404pyq2phy2",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2physol2.png"
  },
  {
    "id": "260404pyq2phy3",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2physol3.png"
  },
  {
    "id": "260404pyq2phy4",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2physol4.png"
  },
  {
    "id": "260404pyq2phy5",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2physol5.png"
  },

  {
    "id": "260404pyq2phy6",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2physol6.png"
  },
  {
    "id": "260404pyq2phy7",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2physol7.png"
  },
  {
    "id": "260404pyq2phy8",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2physol8.png"
  },
  {
    "id": "260404pyq2phy9",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2physol9.png"
  },
  {
    "id": "260404pyq2phy10",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2physol10.png"
  },
  {
    "id": "260404pyq2phy11",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2physol11.png"
  },
  {
    "id": "260404pyq2phy12",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2physol12.png"
  },
  {
    "id": "260404pyq2phy13",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2physol13.png"
  },
  {
    "id": "260404pyq2phy14",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2physol14.png"
  },
  {
    "id": "260404pyq2phy15",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2physol15.png"
  },
  {
    "id": "260404pyq2phy16",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2physol16.png"
  },
  {
    "id": "260404pyq2phy17",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2physol17.png"
  },
  {
    "id": "260404pyq2phy18",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2physol18.png"
  },
  {
    "id": "260404pyq2phy19",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2physol19.png"
  },
  {
    "id": "260404pyq2phy20",
    "id_type": '260404pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260404pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2physol20.png"
  },

  {
    "id": "260404pyq2che1",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol1.png"
  },
  {
    "id": "260404pyq2che2",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2chesol2.png"
  },
  {
    "id": "260404pyq2che3",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol3.png"
  },
  {
    "id": "260404pyq2che4",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol4.png"
  },
  {
    "id": "260404pyq2che5",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2chesol5.png"
  },

  {
    "id": "260404pyq2che6",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol6.png"
  },
  {
    "id": "260404pyq2che7",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol7.png"
  },
  {
    "id": "260404pyq2che8",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol8.png"
  },
  {
    "id": "260404pyq2che9",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2chesol9.png"
  },
  {
    "id": "260404pyq2che10",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2chesol10.png"
  },
  {
    "id": "260404pyq2che11",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2chesol11.png"
  },
  {
    "id": "260404pyq2che12",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol12.png"
  },
  {
    "id": "260404pyq2che13",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2chesol13.png"
  },
  {
    "id": "260404pyq2che14",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2chesol14.png"
  },
  {
    "id": "260404pyq2che15",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260404pyq2chesol15.png"
  },
  {
    "id": "260404pyq2che16",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2chesol16.png"
  },
  {
    "id": "260404pyq2che17",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol17.png"
  },
  {
    "id": "260404pyq2che18",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260404pyq2chesol18.png"
  },
  {
    "id": "260404pyq2che19",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260404pyq2chesol19.png"
  },
  {
    "id": "260404pyq2che80",
    "id_type": '260404pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260404pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260404pyq2chesol20.png"
  },

  {
    "id": "260405pyq1math1",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol1.png"
  },
  {
    "id": "260405pyq1math2",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol2.png"
  },
  {
    "id": "260405pyq1math3",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1mathsol3.png"
  },
  {
    "id": "260405pyq1math4",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol4.png"
  },
  {
    "id": "260405pyq1math5",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol5.png"
  },

  {
    "id": "260405pyq1math6",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol6.png"
  },
  {
    "id": "260405pyq1math7",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol7.png"
  },
  {
    "id": "260405pyq1math8",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol8.png"
  },
  {
    "id": "260405pyq1math9",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol9.png"
  },
  {
    "id": "260405pyq1math10",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol10.png"
  },
  {
    "id": "260405pyq1math11",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1mathsol11.png"
  },
  {
    "id": "260405pyq1math12",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol12.png"
  },
  {
    "id": "260405pyq1math13",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol13.png"
  },
  {
    "id": "260405pyq1math14",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1mathsol14.png"
  },
  {
    "id": "260405pyq1math15",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol15.png"
  },
  {
    "id": "260405pyq1math16",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol16.png"
  },
  {
    "id": "260405pyq1math17",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol17.png"
  },
  {
    "id": "260405pyq1math18",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol18.png"
  },
  {
    "id": "260405pyq1math19",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol19.png"
  },
  {
    "id": "260405pyq1math20",
    "id_type": '260405pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol20.png"
  },


  {
    "id": "260405pyq1phy1",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol1.png"
  },
  {
    "id": "260405pyq1phy2",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol2.png"
  },
  {
    "id": "260405pyq1phy3",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol3.png"
  },
  {
    "id": "260405pyq1phy4",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol4.png"
  },
  {
    "id": "260405pyq1phy5",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol5.png"
  },

  {
    "id": "260405pyq1phy6",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol6.png"
  },
  {
    "id": "260405pyq1phy7",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol7.png"
  },
  {
    "id": "260405pyq1phy8",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol8.png"
  },
  {
    "id": "260405pyq1phy9",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol9.png"
  },
  {
    "id": "260405pyq1phy10",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol10.png"
  },
  {
    "id": "260405pyq1phy11",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol11.png"
  },
  {
    "id": "260405pyq1phy12",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol12.png"
  },
  {
    "id": "260405pyq1phy13",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol13.png"
  },
  {
    "id": "260405pyq1phy14",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol14.png"
  },
  {
    "id": "260405pyq1phy15",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol15.png"
  },
  {
    "id": "260405pyq1phy16",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol16.png"
  },
  {
    "id": "260405pyq1phy17",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol17.png"
  },
  {
    "id": "260405pyq1phy18",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol18.png"
  },
  {
    "id": "260405pyq1phy19",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol19.png"
  },
  {
    "id": "260405pyq1phy20",
    "id_type": '260405pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol20.png"
  },

  {
    "id": "260405pyq1che1",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol1.png"
  },
  {
    "id": "260405pyq1che2",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol2.png"
  },
  {
    "id": "260405pyq1che3",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol3.png"
  },
  {
    "id": "260405pyq1che4",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol4.png"
  },
  {
    "id": "260405pyq1che5",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol5.png"
  },

  {
    "id": "260405pyq1che6",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1chesol6.png"
  },
  {
    "id": "260405pyq1che7",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol7.png"
  },
  {
    "id": "260405pyq1che8",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol8.png"
  },
  {
    "id": "260405pyq1che9",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol9.png"
  },
  {
    "id": "260405pyq1che10",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol10.png"
  },
  {
    "id": "260405pyq1che11",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol11.png"
  },
  {
    "id": "260405pyq1che12",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol12.png"
  },
  {
    "id": "260405pyq1che13",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1chesol13.png"
  },
  {
    "id": "260405pyq1che14",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol14.png"
  },
  {
    "id": "260405pyq1che15",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol15.png"
  },
  {
    "id": "260405pyq1che16",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol16.png"
  },
  {
    "id": "260405pyq1che17",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol17.png"
  },
  {
    "id": "260405pyq1che18",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1chesol18.png"
  },
  {
    "id": "260405pyq1che19",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol19.png"
  },
  {
    "id": "260405pyq1che80",
    "id_type": '260405pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol20.png"
  },

 {
    "id": "260405pyq2math1",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol1.png"
  },
  {
    "id": "260405pyq2math2",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1mathsol2.png"
  },
  {
    "id": "260405pyq2math3",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1mathsol3.png"
  },
  {
    "id": "260405pyq2math4",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol4.png"
  },
  {
    "id": "260405pyq2math5",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol5.png"
  },

  {
    "id": "260405pyq2math6",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1mathsol6.png"
  },
  {
    "id": "260405pyq2math7",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol7.png"
  },
  {
    "id": "260405pyq2math8",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol8.png"
  },
  {
    "id": "260405pyq2math9",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1mathsol9.png"
  },
  {
    "id": "260405pyq2math10",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1mathsol10.png"
  },
  {
    "id": "260405pyq2math11",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol11.png"
  },
  {
    "id": "260405pyq2math12",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol12.png"
  },
  {
    "id": "260405pyq2math13",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol13.png"
  },
  {
    "id": "260405pyq2math14",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol14.png"
  },
  {
    "id": "260405pyq2math15",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol15.png"
  },
  {
    "id": "260405pyq2math16",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol16.png"
  },
  {
    "id": "260405pyq2math17",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1mathsol17.png"
  },
  {
    "id": "260405pyq2math18",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol18.png"
  },
  {
    "id": "260405pyq2math19",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1mathsol19.png"
  },
  {
    "id": "260405pyq2math20",
    "id_type": '260405pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260405pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1mathsol20.png"
  },


  {
    "id": "260405pyq2phy1",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol1.png"
  },
  {
    "id": "260405pyq2phy2",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1physol2.png"
  },
  {
    "id": "260405pyq2phy3",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol3.png"
  },
  {
    "id": "260405pyq2phy4",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol4.png"
  },
  {
    "id": "260405pyq2phy5",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol5.png"
  },

  {
    "id": "260405pyq2phy6",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1physol6.png"
  },
  {
    "id": "260405pyq2phy7",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1physol7.png"
  },
  {
    "id": "260405pyq2phy8",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol8.png"
  },
  {
    "id": "260405pyq2phy9",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol9.png"
  },
  {
    "id": "260405pyq2phy10",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol10.png"
  },
  {
    "id": "260405pyq2phy11",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol11.png"
  },
  {
    "id": "260405pyq2phy12",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol12.png"
  },
  {
    "id": "260405pyq2phy13",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol13.png"
  },
  {
    "id": "260405pyq2phy14",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol14.png"
  },
  {
    "id": "260405pyq2phy15",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1physol15.png"
  },
  {
    "id": "260405pyq2phy16",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol16.png"
  },
  {
    "id": "260405pyq2phy17",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol17.png"
  },
  {
    "id": "260405pyq2phy18",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1physol18.png"
  },
  {
    "id": "260405pyq2phy19",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol19.png"
  },
  {
    "id": "260405pyq2phy20",
    "id_type": '260405pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260405pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1physol20.png"
  },

  {
    "id": "260405pyq2che1",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1chesol1.png"
  },
  {
    "id": "260405pyq2che2",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol2.png"
  },
  {
    "id": "260405pyq2che3",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol3.png"
  },
  {
    "id": "260405pyq2che4",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol4.png"
  },
  {
    "id": "260405pyq2che5",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol5.png"
  },

  {
    "id": "260405pyq2che6",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol6.png"
  },
  {
    "id": "260405pyq2che7",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260405pyq1chesol7.png"
  },
  {
    "id": "260405pyq2che8",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol8.png"
  },
  {
    "id": "260405pyq2che9",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol9.png"
  },
  {
    "id": "260405pyq2che10",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol10.png"
  },
  {
    "id": "260405pyq2che11",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1chesol11.png"
  },
  {
    "id": "260405pyq2che12",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1chesol12.png"
  },
  {
    "id": "260405pyq2che13",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol13.png"
  },
  {
    "id": "260405pyq2che14",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1chesol14.png"
  },
  {
    "id": "260405pyq2che15",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol15.png"
  },
  {
    "id": "260405pyq2che16",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol16.png"
  },
  {
    "id": "260405pyq2che17",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol17.png"
  },
  {
    "id": "260405pyq2che18",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260405pyq1chesol18.png"
  },
  {
    "id": "260405pyq2che19",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260405pyq1chesol19.png"
  },
  {
    "id": "260405pyq2che80",
    "id_type": '260405pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260405pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260405pyq1chesol20.png"
  },


  {
    "id": "260406pyq1math1",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol1.png"
  },
  {
    "id": "260406pyq1math2",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1mathsol2.png"
  },
  {
    "id": "260406pyq1math3",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1mathsol3.png"
  },
  {
    "id": "260406pyq1math4",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1mathsol4.png"
  },
  {
    "id": "260406pyq1math5",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol5.png"
  },

  {
    "id": "260406pyq1math6",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1mathsol6.png"
  },
  {
    "id": "260406pyq1math7",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1mathsol7.png"
  },
  {
    "id": "260406pyq1math8",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1mathsol8.png"
  },
  {
    "id": "260406pyq1math9",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol9.png"
  },
  {
    "id": "260406pyq1math10",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol10.png"
  },
  {
    "id": "260406pyq1math11",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1mathsol11.png"
  },
  {
    "id": "260406pyq1math12",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1mathsol12.png"
  },
  {
    "id": "260406pyq1math13",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol13.png"
  },
  {
    "id": "260406pyq1math14",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol14.png"
  },
  {
    "id": "260406pyq1math15",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1mathsol15.png"
  },
  {
    "id": "260406pyq1math16",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol16.png"
  },
  {
    "id": "260406pyq1math17",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol17.png"
  },
  {
    "id": "260406pyq1math18",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol18.png"
  },
  {
    "id": "260406pyq1math19",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1mathsol19.png"
  },
  {
    "id": "260406pyq1math20",
    "id_type": '260406pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1mathsol20.png"
  },


  {
    "id": "260406pyq1phy1",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1physol1.png"
  },
  {
    "id": "260406pyq1phy2",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1physol2.png"
  },
  {
    "id": "260406pyq1phy3",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1physol3.png"
  },
  {
    "id": "260406pyq1phy4",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1physol4.png"
  },
  {
    "id": "260406pyq1phy5",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1physol5.png"
  },

  {
    "id": "260406pyq1phy6",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1physol6.png"
  },
  {
    "id": "260406pyq1phy7",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1physol7.png"
  },
  {
    "id": "260406pyq1phy8",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1physol8.png"
  },
  {
    "id": "260406pyq1phy9",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1physol9.png"
  },
  {
    "id": "260406pyq1phy10",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1physol10.png"
  },
  {
    "id": "260406pyq1phy11",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1physol11.png"
  },
  {
    "id": "260406pyq1phy12",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1physol12.png"
  },
  {
    "id": "260406pyq1phy13",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1physol13.png"
  },
  {
    "id": "260406pyq1phy14",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1physol14.png"
  },
  {
    "id": "260406pyq1phy15",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1physol15.png"
  },
  {
    "id": "260406pyq1phy16",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1physol16.png"
  },
  {
    "id": "260406pyq1phy17",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1physol17.png"
  },
  {
    "id": "260406pyq1phy18",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1physol18.png"
  },
  {
    "id": "260406pyq1phy19",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1physol19.png"
  },
  {
    "id": "260406pyq1phy20",
    "id_type": '260406pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1physol20.png"
  },

  {
    "id": "260406pyq1che1",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1chesol1.png"
  },
  {
    "id": "260406pyq1che2",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1chesol2.png"
  },
  {
    "id": "260406pyq1che3",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1chesol3.png"
  },
  {
    "id": "260406pyq1che4",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1chesol4.png"
  },
  {
    "id": "260406pyq1che5",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1chesol5.png"
  },

  {
    "id": "260406pyq1che6",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1chesol6.png"
  },
  {
    "id": "260406pyq1che7",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1chesol7.png"
  },
  {
    "id": "260406pyq1che8",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1chesol8.png"
  },
  {
    "id": "260406pyq1che9",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1chesol9.png"
  },
  {
    "id": "260406pyq1che10",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1chesol10.png"
  },
  {
    "id": "260406pyq1che11",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1chesol11.png"
  },
  {
    "id": "260406pyq1che12",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq1chesol12.png"
  },
  {
    "id": "260406pyq1che13",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1chesol13.png"
  },
  {
    "id": "260406pyq1che14",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1chesol14.png"
  },
  {
    "id": "260406pyq1che15",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq1chesol15.png"
  },
  {
    "id": "260406pyq1che16",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1chesol16.png"
  },
  {
    "id": "260406pyq1che17",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1chesol17.png"
  },
  {
    "id": "260406pyq1che18",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1chesol18.png"
  },
  {
    "id": "260406pyq1che19",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq1chesol19.png"
  },
  {
    "id": "260406pyq1che80",
    "id_type": '260406pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq1chesol20.png"
  },


    {
    "id": "260406pyq2math1",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2mathsol1.png"
  },
  {
    "id": "260406pyq2math2",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol2.png"
  },
  {
    "id": "260406pyq2math3",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2mathsol3.png"
  },
  {
    "id": "260406pyq2math4",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2mathsol4.png"
  },
  {
    "id": "260406pyq2math5",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol5.png"
  },

  {
    "id": "260406pyq2math6",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol6.png"
  },
  {
    "id": "260406pyq2math7",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol7.png"
  },
  {
    "id": "260406pyq2math8",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2mathsol8.png"
  },
  {
    "id": "260406pyq2math9",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol9.png"
  },
  {
    "id": "260406pyq2math10",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol10.png"
  },
  {
    "id": "260406pyq2math11",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2mathsol11.png"
  },
  {
    "id": "260406pyq2math12",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2mathsol12.png"
  },
  {
    "id": "260406pyq2math13",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2mathsol13.png"
  },
  {
    "id": "260406pyq2math14",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol14.png"
  },
  {
    "id": "260406pyq2math15",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol15.png"
  },
  {
    "id": "260406pyq2math16",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol16.png"
  },
  {
    "id": "260406pyq2math17",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2mathsol17.png"
  },
  {
    "id": "260406pyq2math18",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2mathsol18.png"
  },
  {
    "id": "260406pyq2math19",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2mathsol19.png"
  },
  {
    "id": "260406pyq2math20",
    "id_type": '260406pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260406pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2mathsol20.png"
  },


  {
    "id": "260406pyq2phy1",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2physol1.png"
  },
  {
    "id": "260406pyq2phy2",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2physol2.png"
  },
  {
    "id": "260406pyq2phy3",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2physol3.png"
  },
  {
    "id": "260406pyq2phy4",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2physol4.png"
  },
  {
    "id": "260406pyq2phy5",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2physol5.png"
  },

  {
    "id": "260406pyq2phy6",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2physol6.png"
  },
  {
    "id": "260406pyq2phy7",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2physol7.png"
  },
  {
    "id": "260406pyq2phy8",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2physol8.png"
  },
  {
    "id": "260406pyq2phy9",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2physol9.png"
  },
  {
    "id": "260406pyq2phy10",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2physol10.png"
  },
  {
    "id": "260406pyq2phy11",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2physol11.png"
  },
  {
    "id": "260406pyq2phy12",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2physol12.png"
  },
  {
    "id": "260406pyq2phy13",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2physol13.png"
  },
  {
    "id": "260406pyq2phy14",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2physol14.png"
  },
  {
    "id": "260406pyq2phy15",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2physol15.png"
  },
  {
    "id": "260406pyq2phy16",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2physol16.png"
  },
  {
    "id": "260406pyq2phy17",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2physol17.png"
  },
  {
    "id": "260406pyq2phy18",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2physol18.png"
  },
  {
    "id": "260406pyq2phy19",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2physol19.png"
  },
  {
    "id": "260406pyq2phy20",
    "id_type": '260406pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260406pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2physol20.png"
  },

  {
    "id": "260406pyq2che1",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2chesol1.png"
  },
  {
    "id": "260406pyq2che2",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2chesol2.png"
  },
  {
    "id": "260406pyq2che3",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2chesol3.png"
  },
  {
    "id": "260406pyq2che4",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2chesol4.png"
  },
  {
    "id": "260406pyq2che5",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2chesol5.png"
  },

  {
    "id": "260406pyq2che6",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2chesol6.png"
  },
  {
    "id": "260406pyq2che7",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2chesol7.png"
  },
  {
    "id": "260406pyq2che8",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2chesol8.png"
  },
  {
    "id": "260406pyq2che9",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2chesol9.png"
  },
  {
    "id": "260406pyq2che10",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2chesol10.png"
  },
  {
    "id": "260406pyq2che11",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2chesol11.png"
  },
  {
    "id": "260406pyq2che12",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2chesol12.png"
  },
  {
    "id": "260406pyq2che13",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2chesol13.png"
  },
  {
    "id": "260406pyq2che14",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260406pyq2chesol14.png"
  },
  {
    "id": "260406pyq2che15",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2chesol15.png"
  },
  {
    "id": "260406pyq2che16",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2chesol16.png"
  },
  {
    "id": "260406pyq2che17",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2chesol17.png"
  },
  {
    "id": "260406pyq2che18",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260406pyq2chesol18.png"
  },
  {
    "id": "260406pyq2che19",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260406pyq2chesol19.png"
  },
  {
    "id": "260406pyq2che80",
    "id_type": '260406pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260406pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260406pyq2chesol20.png"
  },


  {
    "id": "260408pyq2math1",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2mathsol1.png"
  },
  {
    "id": "260408pyq2math2",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2mathsol2.png"
  },
  {
    "id": "260408pyq2math3",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2mathsol3.png"
  },
  {
    "id": "260408pyq2math4",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2mathsol4.png"
  },
  {
    "id": "260408pyq2math5",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2mathsol5.png"
  },

  {
    "id": "260408pyq2math6",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2mathsol6.png"
  },
  {
    "id": "260408pyq2math7",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2mathsol7.png"
  },
  {
    "id": "260408pyq2math8",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2mathsol8.png"
  },
  {
    "id": "260408pyq2math9",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2mathsol9.png"
  },
  {
    "id": "260408pyq2math10",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2mathsol10.png"
  },
  {
    "id": "260408pyq2math11",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2mathsol11.png"
  },
  {
    "id": "260408pyq2math12",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2mathsol12.png"
  },
  {
    "id": "260408pyq2math13",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260408pyq2mathsol13.png"
  },
  {
    "id": "260408pyq2math14",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2mathsol14.png"
  },
  {
    "id": "260408pyq2math15",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2mathsol15.png"
  },
  {
    "id": "260408pyq2math16",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2mathsol16.png"
  },
  {
    "id": "260408pyq2math17",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2mathsol17.png"
  },
  {
    "id": "260408pyq2math18",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2mathsol18.png"
  },
  {
    "id": "260408pyq2math19",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260408pyq2mathsol19.png"
  },
  {
    "id": "260408pyq2math20",
    "id_type": '260408pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260408pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2mathsol20.png"
  },


  {
    "id": "260408pyq2phy1",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2physol1.png"
  },
  {
    "id": "260408pyq2phy2",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2physol2.png"
  },
  {
    "id": "260408pyq2phy3",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2physol3.png"
  },
  {
    "id": "260408pyq2phy4",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260408pyq2physol4.png"
  },
  {
    "id": "260408pyq2phy5",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2physol5.png"
  },

  {
    "id": "260408pyq2phy6",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2physol6.png"
  },
  {
    "id": "260408pyq2phy7",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2physol7.png"
  },
  {
    "id": "260408pyq2phy8",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260408pyq2physol8.png"
  },
  {
    "id": "260408pyq2phy9",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260408pyq2physol9.png"
  },
  {
    "id": "260408pyq2phy10",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2physol10.png"
  },
  {
    "id": "260408pyq2phy11",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2physol11.png"
  },
  {
    "id": "260408pyq2phy12",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2physol12.png"
  },
  {
    "id": "260408pyq2phy13",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260408pyq2physol13.png"
  },
  {
    "id": "260408pyq2phy14",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260408pyq2physol14.png"
  },
  {
    "id": "260408pyq2phy15",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2physol15.png"
  },
  {
    "id": "260408pyq2phy16",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2physol16.png"
  },
  {
    "id": "260408pyq2phy17",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2physol17.png"
  },
  {
    "id": "260408pyq2phy18",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260408pyq2physol18.png"
  },
  {
    "id": "260408pyq2phy19",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2physol19.png"
  },
  {
    "id": "260408pyq2phy20",
    "id_type": '260408pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260408pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2physol20.png"
  },

  {
    "id": "260408pyq2che1",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol1.png"
  },
  {
    "id": "260408pyq2che2",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2chesol2.png"
  },
  {
    "id": "260408pyq2che3",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2chesol3.png"
  },
  {
    "id": "260408pyq2che4",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol4.png"
  },
  {
    "id": "260408pyq2che5",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol5.png"
  },

  {
    "id": "260408pyq2che6",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2chesol6.png"
  },
  {
    "id": "260408pyq2che7",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol7.png"
  },
  {
    "id": "260408pyq2che8",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2chesol8.png"
  },
  {
    "id": "260408pyq2che9",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol9.png"
  },
  {
    "id": "260408pyq2che10",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2chesol10.png"
  },
  {
    "id": "260408pyq2che11",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2chesol11.png"
  },
  {
    "id": "260408pyq2che12",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol12.png"
  },
  {
    "id": "260408pyq2che13",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2chesol13.png"
  },
  {
    "id": "260408pyq2che14",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2chesol14.png"
  },
  {
    "id": "260408pyq2che15",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2chesol15.png"
  },
  {
    "id": "260408pyq2che16",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260408pyq2chesol16.png"
  },
  {
    "id": "260408pyq2che17",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol17.png"
  },
  {
    "id": "260408pyq2che18",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol18.png"
  },
  {
    "id": "260408pyq2che19",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260408pyq2chesol19.png"
  },
  {
    "id": "260408pyq2che20",
    "id_type": '260408pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260408pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",  
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260408pyq2chesol20.png"
  },



]

export default AllQuestions;